import type { ArticleQuantityState } from "../types";

/**
 * Grade a stock figure against a warning and a minimum threshold.
 *
 * Shared by articles and load carriers so the two cannot drift apart: an article graded on
 * what it can still promise and a carrier graded on what stands in the yard both read the same
 * badge for the same numbers.
 *
 * `minimum` is tested before `warning` because it is the harder of the two, and both entity forms
 * require `warning >= minimum`. Testing the looser threshold first would answer `low` for every
 * figure that is in fact under the minimum, and `critical` would name a band that cannot exist.
 *
 * @param available - What can be promised or loaded. Negative is allowed and grades `empty`.
 * @param warning - At or below this, and above the minimum, the row is `low`.
 * @param minimum - At or below this, the row is `critical`.
 * @returns The state a tag or badge colours by.
 */
export function gradeStockQuantity(
	available: number,
	warning: number,
	minimum: number,
): ArticleQuantityState {
	if (available <= 0) return "empty";
	if (available <= minimum) return "critical";
	if (available <= warning) return "low";
	return "ok";
}
